<template>
  <div class="mb-2">
    <slot class="m-0 mb-1"></slot>
    <component :is="tag" class="m-0 ds-text-xs font-semibold text-gray-500 uppercase whitespace-no-wrap" v-html="label"></component>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: false, default: null },
    secondary: { type: Boolean, required: false, default: false }
  },
  computed: {
    tag() {
      return this.secondary ? "h5" : "h4";
    }
  }
};
</script>

<style scoped>
</style>
